var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 1.43a5.4 5.4 0 11-5.2 9.42 5.31 5.31 0 01-3.08.97 5.37 5.37 0 01-5-3.3A5.4 5.4 0 019.5 1.99a5.38 5.38 0 015.2-.55zm-8.28 1.3v.01a3.63 3.63 0 00-2.57 1.07 3.74 3.74 0 000 5.19 3.61 3.61 0 004.36.59 5.4 5.4 0 01.02-6.36 3.53 3.53 0 00-1.81-.5zm6.18 0v.01a3.63 3.63 0 00-1.83.49 5.4 5.4 0 01.02 6.35 3.61 3.61 0 003.22.19 3.68 3.68 0 001.15-5.96 3.55 3.55 0 00-2.56-1.07zM9.5 4.5l-.04.07A3.74 3.74 0 009.5 8.3a3.68 3.68 0 00.01-3.82z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSmall);
export default __webpack_public_path__ + "assets/media/active-small.2114670a.svg";
export { ForwardRef as ReactComponent };